import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';

import APIError from 'types/api_error';
import { UserGroup } from 'types/user_group';

import { useAPI } from 'hooks/api/useAPI';

export type CreateUserGroupParams = {
  name: string;
};

export function useCreateUserGroup({
  onSettled,
  ...options
}: UseMutationOptions<UserGroup, APIError, CreateUserGroupParams> = {}) {
  const queryClient = useQueryClient();
  const { applicationID, client } = useAPI();

  return useMutation(
    async (params) => {
      const { data } = await client.post<UserGroup>(
        `/apps/${applicationID}/user_groups`,
        params
      );
      return data;
    },
    {
      ...options,
      onSettled(...args) {
        onSettled?.(...args);
        queryClient.invalidateQueries(['user-groups']);
      },
    }
  );
}
